import React from 'react';
import { Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { setView } from '@store/policies/precisionPolicy/actions';
import { isScheduleViewSelector } from '@store/policies/precisionPolicy/selectors';
import { ViewTypes } from '@store/policies/precisionPolicy/reducers';
import { EyeOutlined } from '@ant-design/icons';

function ViewAllSchedulesButton() {
  const dispatch = useDispatch();
  const isScheduleView = useSelector(isScheduleViewSelector);

  if (isScheduleView) {
    return null;
  }

  const handleClick = () => {
    dispatch(setView(ViewTypes.schedules));
  };

  return (
    <>
      <Button onClick={handleClick} icon={<EyeOutlined />}>
        View All Schedules
      </Button>
    </>
  );
}

export default ViewAllSchedulesButton;
